import React from 'react';
import ExtranetLogo from '../components/nav/ExtranetLogo';
import 'bulma/css/bulma.min.css';

function NotFound() {

    //set up browser title
    const pageTitle = '404 Not Found';
    document.title = pageTitle;

    return (
        <div>
            <nav>
                <div>
                    <ExtranetLogo></ExtranetLogo>
                </div>
            </nav>
            <div className="columns">
                <div className="column notification is-warning is-10 has-text-centered">
                    <h1 className="title">Oops! This seems an invalid URL</h1>
                </div>
            </div>
        </div>
    )
}

export default NotFound